import { IEventDetailedRound } from '../../../../../../store/admin/eventRounds/store';

import { IStateDispatchActions } from '../TeeSheetCreator.context';
import { IOnPlayerAdd } from './onPlayerAdd';

export type IOnSelectPlayerToAdd = (enrollmentId: number, round: IEventDetailedRound) => () => void;

export type IOnSelectPlayerToAddAugmented = (onPlayerAdd: IOnPlayerAdd) => IOnSelectPlayerToAdd;

export const onSelectPlayerToAdd: IStateDispatchActions<IOnSelectPlayerToAddAugmented> = (
  state,
  dispatch
) => onPlayerAdd => (enrollmentId, round) => async () => {
  const { selectedGroup, selectedSeat } = state;

  const enrollment = (round && round.enrollments ? round.enrollments : []).find(
    e => e.id === enrollmentId
  );
  if (enrollment && enrollment.status !== 'active') {
    dispatch({
      type: 'set',
      value: { attribute: 'dialogActions', value: { toAdd: enrollmentId } }
    });

    dispatch({
      type: 'set',
      value: {
        attribute: 'dialogText',
        value: `Are you sure you want to add ${enrollment.user.firstName}
            ${enrollment.user.lastName} to this group?, this action will generate
            charges to this user`
      }
    });

    dispatch({
      type: 'set',
      value: { attribute: 'dialogTitle', value: 'Confirm to add player from the Waitlist' }
    });
    dispatch({ type: 'set', value: { attribute: 'dialogOpen', value: true } });
  } else {
    // TODO: Handle backend error
    await onPlayerAdd(
      { enrollment: enrollmentId, group: selectedGroup, seat: selectedSeat },
      Number(selectedGroup)
    );

    dispatch({ type: 'set', value: { attribute: 'selectedGroup', value: 0 } });
    dispatch({ type: 'set', value: { attribute: 'selectedSeat', value: 0 } });
  }
};
